import type { BaseEntity } from './BaseEntity';
import type { Contact } from './Contact';
import type { InventoryItem } from "./InventoryItem";
import { PurchaseOrder } from './PurchaseOrder';

export interface Vendor extends BaseEntity {
  name: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  contactId?: number | null;
  contact?: Contact;
  inventoryItems?: InventoryItem[];
  purchaseOrders?: PurchaseOrder[];
}

type ValidationResult = { issues: { message: string; path: (keyof Vendor)[] }[] };

export function validate(vendor: Partial<Vendor>): ValidationResult {
  let issues: ValidationResult['issues'] = [];

  if (!vendor.name) {
    issues = [...issues, { message: 'Name is required', path: ['name'] }];
  }

  return { issues };
}